import { render, staticRenderFns } from "./FuelTanksAccountingSystemPage.vue?vue&type=template&id=39a4ffc2"
import script from "./FuelTanksAccountingSystemPage.vue?vue&type=script&lang=js"
export * from "./FuelTanksAccountingSystemPage.vue?vue&type=script&lang=js"
import style0 from "./FuelTanksAccountingSystemPage.vue?vue&type=style&index=0&id=39a4ffc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports